var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aplayer',{staticClass:"custom-aplayer",attrs:{"music":{
  title: _vm.getPlaylistFromFiles[0].title,
  src: _vm.getPlaylistFromFiles[0].src,
  artist: _vm.getPlaylistFromFiles[0].extension,
  pic: this.fileGroupInfo.preview_file,
},"list":_vm.getPlaylistFromFiles}})
}
var staticRenderFns = []

export { render, staticRenderFns }